import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import "./users.css";
import axios from "axios";
import { Box, Button, Container, Table, Pagination, TableBody, TableCell, TableHead, TableRow, TextField, Select, MenuItem, Checkbox, ListItemText, OutlinedInput } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { t } from "i18next";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (config.data && config.data.id === undefined && config.data.userId) {
         
        }
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

const chimMoiOptions = [
    { label: "TẤT CẢ GAME", value: "all" },
    { label: "Tài Xỉu MD5", value: "md560s" },
    { label: "Xổ Số 75s", value: "xs75s" },
    { label: "Xổ Số 120s", value: "xs120s" },
    
    { label: "TX 45s - Sảnh 1", value: "tx45ssanh1" },
    { label: "TX 45s - Sảnh 2", value: "tx45ssanh2" },
    { label: "TX 45s - Sảnh 3", value: "tx45ssanh3" },
    { label: "TX 45s - Sảnh 4", value: "tx45ssanh4" },
    { label: "TX 45s - Sảnh 5", value: "tx45ssanh5" },
    { label: "TX 45s - Sảnh 6", value: "tx45ssanh6" },
    
    { label: "TX 60s - Sảnh 1", value: "tx60ssanh1" },
    { label: "TX 60s - Sảnh 2", value: "tx60ssanh2" },
    { label: "TX 60s - Sảnh 3", value: "tx60ssanh3" },
    { label: "TX 60s - Sảnh 4", value: "tx60ssanh4" },
    { label: "TX 60s - Sảnh 5", value: "tx60ssanh5" },
    { label: "TX 60s - Sảnh 6", value: "tx60ssanh6" },
    
    { label: "XĐ 45s - Sảnh 1", value: "xd45ssanh1" },
    { label: "XĐ 45s - Sảnh 2", value: "xd45ssanh2" },
    { label: "XĐ 45s - Sảnh 3", value: "xd45ssanh3" },
    { label: "XĐ 45s - Sảnh 4", value: "xd45ssanh4" },
    { label: "XĐ 45s - Sảnh 5", value: "xd45ssanh5" },
    { label: "XĐ 45s - Sảnh 6", value: "xd45ssanh6" },
    
    { label: "XĐ 60s - Sảnh 1", value: "xd60ssanh1" },
    { label: "XĐ 60s - Sảnh 2", value: "xd60ssanh2" },
    { label: "XĐ 60s - Sảnh 3", value: "xd60ssanh3" },
    { label: "XĐ 60s - Sảnh 4", value: "xd60ssanh4" },
    { label: "XĐ 60s - Sảnh 5", value: "xd60ssanh5" },
    { label: "XĐ 60s - Sảnh 6", value: "xd60ssanh6" },
];

function Users() {
    const [users, setUsers] = useState(null);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");

    const navigate = useNavigate();
    const typingTimeoutRef = useRef(null);
    const limit = 12;

    const fetchUsers = () => {
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getall`, {
                params: {
                    page: page,
                    limit: limit,
                    search: searchQuery 
                }
            })
            .then((res) => {
                setUsers(res.data.data);
                setTotalPages(res.data.totalPages || 1);
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchUsers();
    }, [page, searchQuery]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        
        typingTimeoutRef.current = setTimeout(() => {
            setSearchQuery(value);
            setPage(1);
        }, 500);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    function formatDate(m) {
        const d = new Date(m);
        return `${d.getFullYear()}/${("0" + (d.getMonth() + 1)).slice(-2)}/${("0" + d.getDate()).slice(-2)} ${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}`;
    }

    const handleSetChimMoi = (userId, winValue) => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/auth/update`, {
            id: userId,
            win: winValue
        }).then(() => {
            fetchUsers();
            swal(t("success"), "Đã cập nhật tính năng Auto Win!", "success");
        }).catch(() => {
            setLoading(false);
            swal(t("error"), "Có lỗi xảy ra khi cập nhật!", "error");
        });
    };

    const handleMultiSelectChange = (userId, event) => {
        let selectedValues = event.target.value;

        if (selectedValues.includes("all")) {
            if (selectedValues[selectedValues.length - 1] === "all") {
                selectedValues = ["all"]; 
            } else {
                selectedValues = selectedValues.filter(val => val !== "all"); 
            }
        }
        const finalWinString = selectedValues.join(",");
        handleSetChimMoi(userId, finalWinString);
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 1 }}>
                    {loading && (
                        <div className="loading" style={{ maxWidth: "100%", zIndex: 9999 }}>
                            <div className="loader"></div>
                        </div>
                    )}
                    <Container maxWidth={false}>
                        <div className="container_set">{t("users")}</div>
                        <div className="form_set">
                            <Box>
                                <TextField 
                                    onChange={handleSearchChange} 
                                    placeholder={t("search")} 
                                    fullWidth
                                    sx={{ mb: 2 }}
                                />
                                <Table className="table-admin">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>ID</TableCell>
                                            <TableCell>{t("username")}</TableCell>
                                            <TableCell>{t("balance")}</TableCell>
                                            <TableCell sx={{ minWidth: "200px" }}>{t("with_reg")}</TableCell>
                                            
                                            <TableCell sx={{ minWidth: "250px", color: "#d32f2f", fontWeight: "bold" }}>AUTO WIN</TableCell>
                                            
                                            <TableCell>{t("reward")}</TableCell>
                                            <TableCell>{t("bank")}</TableCell>
                                            <TableCell>{t("phone")}</TableCell>
                                            <TableCell>{t("totalbet")}</TableCell>
                                            <TableCell>{t("ip")}</TableCell>
                                            <TableCell>{t("created")}</TableCell>
                                            <TableCell>{t("more")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {users && users.length > 0 ? (
                                            users.map((item) => {
                                                // Tách chuỗi win thành mảng để đưa vào Select Multiple
                                                const currentWinArray = item?.win ? item.win.split(',').map(s => s.trim()) : [];
                                                
                                                return (
                                                    <TableRow key={item._id} sx={{ verticalAlign: "top", backgroundColor: item?.win ? "rgba(255, 0, 0, 0.05)" : "transparent" }}>
                                                        <TableCell>{item?.iduser}</TableCell>
                                                        <TableCell sx={{ fontWeight: item?.win ? "bold" : "normal", color: item?.win ? "#d32f2f" : "inherit" }}>
                                                            {item?.username}
                                                        </TableCell>
                                                        <TableCell>{item?.money?.toLocaleString("vi-VN")}</TableCell>
                                                        
                                                        <TableCell>
                                                            <form onSubmit={(e) => {
                                                                e.preventDefault();
                                                                setLoading(true);
                                                                axios.post(`${process.env.REACT_APP_API_URL}/auth/update`, {
                                                                    id: item?._id,
                                                                    money: e.target.money.value,
                                                                    type: e.target.type.value
                                                                }).then(() => {
                                                                    fetchUsers();
                                                                    swal(t("success"), "", "success");
                                                                    e.target.reset();
                                                                }).catch(() => setLoading(false));
                                                            }}>
                                                                <input style={{ width: "80px", padding: "4px", borderRadius: "4px", border: "1px solid #ccc" }} name="money" type="number" placeholder={t("money")} required />
                                                                <Button type="submit" size="small" variant="contained" sx={{ ml: 1 }}>{t("submit")}</Button>
                                                                <br />
                                                                <div style={{ marginTop: "5px", fontSize: "13px" }}>
                                                                    <input name="type" type="radio" defaultChecked value="0" style={{ cursor: "pointer" }} /> Nạp tiền
                                                                    <input name="type" type="radio" value="1" style={{ cursor: "pointer", marginLeft: "10px" }} /> Trừ tiền
                                                                </div>
                                                            </form>
                                                        </TableCell>

                                                        {/* 🔥 DROPDOWN CHỌN NHIỀU SẢNH BẰNG MATERIAL UI 🔥 */}
                                                        <TableCell>
                                                            <Select
                                                                multiple
                                                                displayEmpty
                                                                value={currentWinArray}
                                                                onChange={(e) => handleMultiSelectChange(item._id, e)}
                                                                input={<OutlinedInput size="small" sx={{ 
                                                                    minWidth: "100%", 
                                                                    bgcolor: item?.win ? "#ffebee" : "#fff",
                                                                    fontWeight: item?.win ? "bold" : "normal",
                                                                    color: item?.win ? "#d32f2f" : "#333"
                                                                }} />}
                                                                renderValue={(selected) => {
                                                                    if (selected.length === 0) return <em style={{ color: '#aaa', fontStyle: 'normal' }}>Bình thường (Trống)</em>;
                                                                    if (selected.includes("all")) return "TẤT CẢ GAME";
                                                                    
                                                                    // Map value thành Label hiển thị cho đẹp
                                                                    return selected.map(val => {
                                                                        const found = chimMoiOptions.find(o => o.value === val);
                                                                        return found ? found.label : val;
                                                                    }).join(', ');
                                                                }}
                                                                MenuProps={{
                                                                    PaperProps: { style: { maxHeight: 400, width: 250 } }
                                                                }}
                                                            >
                                                                {chimMoiOptions.map((opt) => (
                                                                    <MenuItem key={opt.value} value={opt.value} sx={{ py: 0 }}>
                                                                        <Checkbox checked={currentWinArray.indexOf(opt.value) > -1} />
                                                                        <ListItemText primary={opt.label} primaryTypographyProps={{ fontSize: '14px', fontWeight: opt.value === 'all' ? 'bold' : 'normal', color: opt.value === 'all' ? 'red' : 'inherit' }} />
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </TableCell>

                                                        <TableCell>
                                                            <form onSubmit={(e) => {
                                                                e.preventDefault();
                                                                setLoading(true);
                                                                axios.post(`${process.env.REACT_APP_API_URL}/auth/adminthuong`, {
                                                                    id: item?._id,
                                                                    money: Number(e.target.money.value),
                                                                    detail: e.target.detail.value
                                                                }).then(() => {
                                                                    fetchUsers();
                                                                    swal(t("success"), "", "success");
                                                                    e.target.reset();
                                                                }).catch(() => setLoading(false));
                                                            }}>
                                                                <input name="detail" type="text" placeholder={t("content")} style={{ display: "block", width: "100px", marginBottom: "4px", padding: "4px", borderRadius: "4px", border: "1px solid #ccc" }} />
                                                                <input name="money" type="number" placeholder={t("money")} style={{ display: "block", width: "100px", padding: "4px", borderRadius: "4px", border: "1px solid #ccc" }} required />
                                                                <Button type="submit" size="small" variant="contained" sx={{ mt: 1 }}>{t("submit")}</Button>
                                                            </form>
                                                        </TableCell>

                                                        <TableCell>
                                                            <span style={{ color: "#eb2222", fontWeight: "bold" }}>{item?.name_bank}</span><br />
                                                            {item?.bank}<br />{item?.stk_bank}
                                                        </TableCell>
                                                        <TableCell>{item?.sdt ? "0" + item?.sdt : ""}</TableCell>
                                                        <TableCell>{item?.totalbet?.toLocaleString("vi-VN")}</TableCell>
                                                        <TableCell sx={{ maxWidth: "100px", wordBreak: "break-word" }}>{item?.ip}</TableCell>
                                                        <TableCell>{formatDate(item?.createdAt)}</TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: "flex", gap: 1, flexDirection: "column" }}>
                                                                <Button 
                                                                    variant="outlined" 
                                                                    size="small"
                                                                    color={item?.isLock ? "success" : "error"}
                                                                    onClick={() => {
                                                                        setLoading(true);
                                                                        axios.post(`${process.env.REACT_APP_API_URL}/auth/lockkey`, { id: item?._id, isLock: !item?.isLock })
                                                                            .then(() => {
                                                                                fetchUsers();
                                                                                swal(t("success"), "", "success");
                                                                            }).catch(() => setLoading(false));
                                                                    }}
                                                                >
                                                                    {item?.isLock ? t("unlock") : t("lock")}
                                                                </Button>
                                                                <Button variant="contained" size="small" onClick={() => navigate(`/admin/user/${item?._id}`)}>{t('view')}</Button>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={12} align="center">{t('empty')}</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </Box>
                        </div>
                        <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                            <Pagination 
                                color="primary" 
                                count={totalPages} 
                                page={page} 
                                onChange={handleChangePage} 
                            />
                        </Box>
                    </Container>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}
export default Users;